import React, { Component, PropTypes } from 'react'
import CSSModules from 'react-css-modules'
import config from '../../config'
import format from '../../helpers/format'
// import { Chart } from '../'
import Styles from './KpiList.css'

@CSSModules(Styles, {allowMultiple:true})
export default class PillarScore extends Component {
  static propTypes = {
    fund: PropTypes.object.isRequired,
    issueId: PropTypes.string.isRequired,
    pillarId: PropTypes.string.isRequired,
  }
  //
  constructor(props){
    super(props)
    const alphabet = {
      'a': 0,
      'b': 1,
      'c': 2,
      'd': 3,
      'e': 4,
      'f': 5,
      'g': 6
    }
    const pillarIdAsInt = alphabet[props.pillarId]

    const pillarPointsDenominator = config.sjfKpiConfig[props.issueId][pillarIdAsInt][2]
    const scoreField = props.issueId+'_score_'+props.pillarId
    let scoreValue = props.fund[scoreField]
    const scoreValueNorm = pillarPointsDenominator > 0 ?
      props.fund[scoreField] / pillarPointsDenominator * 100 :
      0

    // 0 if the score is presented un-normalized. e.g. out of 40 points, etc.
    // 1 if the score is normalized to be out of 100 points.
    // As of release, we decided to go with none of these being normalized.
    const issueNormConfig = { 'gef': 0, 'dei': 0, 'rji': 0, 'hrc': 0 }

    /**
     * TEMPORARY HACK
     * 
     * If the issueId is 'dei', we need to apply weighting to pillar scores.
     * Eventually we will move this logic to the data pipeline.
     * For release, this is a surface overwrite of the database.
     * 
     * Pillar score  Max  Weight
     * dei_score_a   2    25
     * dei_score_b   4    5
     * dei_score_c   9    20
     * dei_score_d   9    20
     * dei_score_e   9    20
     * dei_score_f   1    10
     * 
     * Each DEI pillar score needs to be:
     * - DIVIDED by MAX
     * - MULTIPLIED by WEIGHT
     * - ROUNDED to INT
     * 
     */
    if (props.issueId === 'dei') {
      const max = {
        'a': 2,
        'b': 4,
        'c': 9,
        'd': 9,
        'e': 9,
        'f': 1,
      }[props.pillarId]
      const weight = {
        'a': 25,
        'b': 5,
        'c': 20,
        'd': 20,
        'e': 20,
        'f': 10,
      }[props.pillarId]
      scoreValue = Math.round((scoreValue / max) * weight)
    }

    const formattedScoreValue = (v) => {
      return v > -1000 ? format.number(v) : '-'
    }
    //
    this.state = {
      scoreValue: issueNormConfig[props.issueId] ?
        formattedScoreValue(scoreValueNorm) :
        formattedScoreValue(scoreValue),
      denominator: issueNormConfig[props.issueId] ? 100 : pillarPointsDenominator,
      scoreValueNorm
    }
  }
  //
  render() {
    return <div styleName='pillar-score-wrap'>
      <div>
        {this.state.scoreValue} <span styleName='out-of'>/ {this.state.denominator}</span>
      </div>

      { /* <div>
        <Chart
          gefScore={String(this.state.scoreValueNorm)}
          gefStyle={format.scoreStyle(this.state.scoreValueNorm)}
          type='small'
        />
      </div> */ }

    </div>
  }
}